import React from 'react'
import MediaWithShimmer from './MediaWithShimmer'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import heroVideo from '../imgs/hero.mp4'

const Hero = () => {
  const { language } = useLanguage()
  const t = translations.hero
  const [videoLoaded, setVideoLoaded] = React.useState(false)
  const [isMuted, setIsMuted] = React.useState(true)
  const videoRef = React.useRef(null)

  React.useEffect(() => {
    const video = videoRef.current
    if (!video) return

    // Always start muted everywhere (desktop + mobile) —
    // this gives максимально надёжный autoplay во всех браузерах.
    video.muted = true
    setIsMuted(true)

    video
      .play()
      .catch(() => {
        // Игнорируем ошибки автоплея: браузер может заблокировать,
        // но компонент при этом не ломается.
      })
  }, [])

  const handleAnchorClick = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault()
      const id = href.substring(1) // Remove '#'
      const element = document.getElementById(id)
      if (element) {
        const headerOffset = window.innerWidth < 640 ? 120 : 80
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }

  return (
    <>
      <section
        id="hero"
        className="relative w-full bg-white overflow-hidden h-[210px] mt-[60px] sm:h-[680px] sm:mt-[80px] sm:flex items-center justify-center"
      >
      {/* Background Video - Woman in White Dress (without shimmer to avoid size flicker) */}
      <div className="absolute inset-0 overflow-hidden">
        {!videoLoaded && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-black/40">
            <div className="flex space-x-2 translate-y-4 md:translate-y-6">
              <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-white/90 animate-bounce" style={{ animationDelay: '0s' }}></span>
              <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-white/90 animate-bounce" style={{ animationDelay: '0.15s' }}></span>
              <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-white/90 animate-bounce" style={{ animationDelay: '0.3s' }}></span>
            </div>
          </div>
        )}
        <video
          ref={videoRef}
          className="w-full h-full object-cover object-center mx-auto"
          autoPlay
          loop
          muted={isMuted}
          playsInline
          preload="auto"
          src={heroVideo}
          onLoadedData={() => setVideoLoaded(true)}
        />
        <button
          type="button"
          onClick={() => {
            const video = videoRef.current
            if (video) {
              const nextMuted = !isMuted
              video.muted = nextMuted
              if (!video.paused) {
                setIsMuted(nextMuted)
              } else {
                video
                  .play()
                  .then(() => {
                    setIsMuted(nextMuted)
                  })
                  .catch(() => {
                    // ignore autoplay errors
                  })
              }
            }
          }}
          className="absolute z-20 bottom-0 right-0 md:bottom-6 md:right-6 px-2 py-1 md:px-3 md:py-1.5 rounded-full bg-black/60 text-white text-[10px] md:text-xs montserrat tracking-[0.18em] uppercase"
        >
          {isMuted ? 'Sound On' : 'Sound Off'}
        </button>
      </div>
      {/* Main Content */}
      <div className="absolute inset-0 z-10 w-full flex flex-col items-center justify-center px-6 py-10 sm:relative sm:h-full">
        <div className="max-w-7xl mx-auto text-center">
          {/* Main Title */}
          <div className="mb-6">
            <div className="mb-3">
              <div className="text-sm tracking-[0.35em] text-white/95 font-light montserrat drop-shadow-[0_1px_6px_rgba(0,0,0,0.6)]">
                {language === 'ru' ? 'Показ мод в Дубае, 2022' : 'Fashion Show in Dubai 2022'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default Hero
